import React, { useMemo } from 'react';
import { Breadcrumb as ANTBreadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import breadcrumbNameMap from '../../../routes/sitemap';
import { RightOutlined } from '@ant-design/icons';

const style = {
  link: {
    color: '#262626',
    fontWeight: '500',
  },
};

const Breadcrumb = ({ location }) => {
  const breadcrumbItems = useMemo(() => {
    const pathSnippets = location.pathname.split('/').filter((i) => i);
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;

      return breadcrumbNameMap[url] ? (
        <ANTBreadcrumb.Item key={url}>
          <Link style={style.link} to={url}>
            {breadcrumbNameMap[url]}
          </Link>
        </ANTBreadcrumb.Item>
      ) : null;
    });

    // Requester edit/review pages belong to a specific campaign: insert a
    // "Details" crumb linking to that campaign between Campaigns and Requester.
    const requesterMatch = location.pathname.match(
      /^\/campaigns\/requester\/(?:edit|review)\/([^/]+)/
    );
    if (requesterMatch) {
      const detailsUrl = `/campaigns/details/${requesterMatch[1]}`;
      extraBreadcrumbItems.splice(
        1,
        0,
        <ANTBreadcrumb.Item key={detailsUrl}>
          <Link style={style.link} to={detailsUrl}>
            {breadcrumbNameMap['/campaigns/details']}
          </Link>
        </ANTBreadcrumb.Item>
      );
    }

    return [
      <ANTBreadcrumb.Item key="home">
        <Link style={style.link} to="/">
          Home
        </Link>
      </ANTBreadcrumb.Item>,
    ].concat(extraBreadcrumbItems);
  }, [location.pathname]);

  return (
    <ANTBreadcrumb separator={<RightOutlined />} style={{ minWidth: '190px', margin: '20px' }}>
      {breadcrumbItems}
    </ANTBreadcrumb>
  );
};

export default Breadcrumb;
